import {min, max} from 'lodash-es'

export default function earliestPromoPaymentDate (
  {relativeTo, days, date},
  departure,
  bookingDate
) {
  const relativeDate =
    'booking' === relativeTo
      ? bookingDate.addDays(days)
      : 'departure' === relativeTo
        ? departure.startDate.addDays(-days)
        : null
  const earliest = min([date, relativeDate])
  if (earliest) {
    return min([
      max([earliest, bookingDate]),
      departure.startDate,
    ])
  }

  return earliest
}
